import { render, staticRenderFns } from "./jobsNeed.vue?vue&type=template&id=6c9db79e"
import script from "./jobsNeed.vue?vue&type=script&lang=js"
export * from "./jobsNeed.vue?vue&type=script&lang=js"
import style0 from "./jobsNeed.vue?vue&type=style&index=0&id=6c9db79e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports